(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/router.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/router.js');
"use strict";

var _svs$tickets;

const Router = svs.app.ReactRouter.PlayerRouter;
const Route = svs.app.ReactRouter.Route;
const Gift = svs.tickets_giftshop.gift.Gift;
const Preview = svs.tickets_giftshop.preview.Preview;
const NavigationBack = svs.tur.NavigationBack;
const store = svs.tickets_giftshop.store;
const _svs$tickets_giftshop = svs.tickets_giftshop.constants.routes,
  GIFT_ROUTE = _svs$tickets_giftshop.GIFT_ROUTE,
  PREVIEW_ROUTE = _svs$tickets_giftshop.PREVIEW_ROUTE;
const isFeatureLobbyEnabled = Boolean((_svs$tickets = svs.tickets) === null || _svs$tickets === void 0 || (_svs$tickets = _svs$tickets.data) === null || _svs$tickets === void 0 || (_svs$tickets = _svs$tickets.templateConfig) === null || _svs$tickets === void 0 ? void 0 : _svs$tickets.showTrissNextLobby);
const getTrissMorePath = () => "".concat(svs.core.urlMapping.get('trissHome').replace(/\/$/, ''), "/mer");
const GiftshopRoutes = () => {
  const history = ReactRouterDOM.useHistory();
  const navigationRoutes = {
    [GIFT_ROUTE]: {
      text: 'Start',
      navigate: () => svs.utils.url.navigate(getTrissMorePath())
    },
    [PREVIEW_ROUTE]: {
      text: 'Ge bort',
      navigate: () => history.push(GIFT_ROUTE)
    }
  };
  return React.createElement(React.Fragment, null, isFeatureLobbyEnabled && React.createElement(NavigationBack, {
    brand: "next-lobby",
    routes: navigationRoutes
  }), React.createElement(Route, {
    component: Gift,
    exact: true,
    path: GIFT_ROUTE
  }), React.createElement(Route, {
    component: Preview,
    exact: true,
    path: PREVIEW_ROUTE
  }));
};
const TicketGiftshopRouter = () => React.createElement(ReactRedux.Provider, {
  store: store
}, React.createElement(Router, {
  basename: svs.core.data.baseUrl
}, React.createElement(GiftshopRoutes, null)));
svs.tickets_giftshop.Router = TicketGiftshopRouter;

 })(window);